export default "__VITE_ASSET__BYb8_a68__"